import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, Trash2, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DeleteAccountModal from "../../components/DeleteAccountModal";

const AdvancedPage = () => {
  const { t } = useTranslation();
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);

  return (
    <div className="bg-light-background dark:bg-dark-background font-sans page">
      <header className="bg-white dark:bg-dark-bg shadow-sm sticky top-0 z-10 section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center">
          <Link
            to="/profile"
            className="text-light-foreground dark:text-dark-foreground hover:text-primary-100 transition-colors"
          >
            <ChevronLeft className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold ml-4 text-light-foreground dark:text-dark-foreground">
            {t("profile.advanced.title")}
          </h1>
        </div>
      </header>

      <main className="p-3">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white dark:bg-dark-bg rounded-lg shadow-md overflow-hidden section"
        >
          <nav>
            {/* Delete Account */}
            <button
              onClick={() => setShowDeleteAccountModal(true)}
              className="flex items-center justify-between w-full p-4 hover:bg-light-gray-100 dark:hover:bg-dark-gray-700 transition-colors text-left"
            >
              <div className="flex items-center">
                <Trash2 className="w-6 h-6 text-light-gray-500 dark:text-dark-gray-400 mr-3" />
                <div className="flex flex-col">
                  <span className="text-light-foreground dark:text-dark-foreground font-medium">
                    {t("profile.deleteAccount")}
                  </span>
                  <span className="text-xs text-light-gray-500 dark:text-dark-gray-400 mt-0.5">
                    {t("profile.deleteAccountWarning")}
                  </span>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-light-gray-400 dark:text-dark-gray-400" />
            </button>
          </nav>
        </motion.div>
      </main>

      <DeleteAccountModal
        isOpen={showDeleteAccountModal}
        onClose={() => setShowDeleteAccountModal(false)}
      />
    </div>
  );
};

export default AdvancedPage;
